import { render } from "./routeTab.vue?vue&type=template&id=341256ba"
const script = {}

import "./routeTab.vue?vue&type=style&index=0&id=341256ba&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__